import React, { useContext, useEffect } from 'react'
import OTPVerifyForm from './OTPVerifyForm'
import Context from '../../app_context/Context';
import PhoneForm from './PhoneForm';

export default function Page() {
    const { site_title, set_site_title, lineData, setLineData, setUserData } = useContext(Context);

    useEffect(() => {
        document.body.style.removeProperty('margin-right');
        document.body.style.removeProperty('padding-right');
        document.body.style.removeProperty('overflow');
    })

    return (
        <div>
            <OTPVerifyForm lineData={lineData} setUserData={setUserData} />
        </div>
    )
}
